import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';

import { forgotPassword, getMe, login, logout, resetPassword, verifyResetCode } from '../api';
import { i18n } from '../i18n';
import { authReducerActions } from '../store/reducers';
import { getErrorMessage, notify } from '../utils';

export const useMe = () => {
  const dispatch = useDispatch();
  const isGuest = useSelector(state => state.authReducer.isGuest);

  return useQuery(
    'me',
    async () => {
      const res = await getMe();
      return res.data;
    },
    {
      enabled: !isGuest,
      retry: false,
      onSuccess: data => dispatch(authReducerActions.updateProfile(data)),
    },
  );
};

export const useLogin = () => {
  return useMutation(login, {
    onSuccess: res => {
      const data = res.data;
      localStorage.setItem('token', data[`user-token`]);
      notify('success', i18n.t('notify.loginSuccess'));
    },
    onError: err => {
      notify('error', getErrorMessage(err));
    },
  });
};

export const useLogout = () => {
  const queryClient = useQueryClient();

  return useMutation(logout, {
    onSuccess: () => {
      localStorage.removeItem('token');
      queryClient.invalidateQueries();
      notify('success', i18n.t('notify.logoutSuccess'));
    },
    onError: () => {
      notify('error', i18n.t('notify.logoutError'));
    },
  });
};

export const useForgotPassword = () => useMutation(forgotPassword);

export const useVerifyResetCode = () => useMutation(verifyResetCode);

export const useResetPassword = () => useMutation(resetPassword);
